import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.permisoVista('multiplicadores', 'r'))?_c(VCol,{attrs:{"cols":"12"}},[_c(VDataTable,{attrs:{"items":_vm.piezas,"headers":_vm.headersPiezas},scopedSlots:_vm._u([{key:"item.cantidad",fn:function(ref){
var item = ref.item;
var idx = ref.idx;
return [(_vm.permisoVista('multiplicadores', 'u'))?_c('number-input',{key:("numin-" + idx),attrs:{"value":item.cantidad,"controls":"","inline":"","size":"small","min":"1","step":1,"center":""},on:{"change":function($event){return _vm.realizarPeticion($event,item)}}}):_vm._e()]}}],null,false,3793617948)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }